/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

/**
 * Define a new proptype role base on a specific React Component
 * @param  {...any} types = React Component
 */
export const childrenOf = (...types) => {
  const fieldType = PropTypes.shape({
    type: PropTypes.oneOf(types),
  });

  return PropTypes.oneOfType([
    fieldType,
    PropTypes.arrayOf(fieldType),
  ]);
};

/**
 * Check proptype of deep enum structure inside other structure.
 * @param {*} props = props of react component
 * @param {*} propName = specific prop name
 * @param {*} enumType = type of enum to search
 */
export const recursivePropTypeCheck = (props, propName, enumType) => {
  console.log(props, propName, enumType)
  let result = false;
  Object.values(enumType).forEach((value) => {
    if (value === props[propName]) {
      result = true;
    }
    if (typeof value === 'object') {
      result = recursivePropTypeCheck(props, propName, value);
    }
  });
  return result;
};
